import { useTranslation } from "react-i18next";
import { LuExternalLink, LuReply } from "react-icons/lu";
import { isEmpty } from "lodash-es";

// URL tombol bisa dibuka hanya bila sudah final (http/https, tanpa placeholder
// `{{n}}` yang belum terisi).
const getOpenableUrl = (button) => {
  const url = button?.type === "URL" ? button?.url : "";
  return /^https?:\/\/\S+$/.test(url || "") && !/\{\{.*?\}\}/.test(url)
    ? url
    : null;
};

// Daftar tombol template (QUICK_REPLY / URL) untuk pratinjau, dipakai di form
// template, modal kirim template, dan bubble chat channel inhouse.
// `clickable`: tombol tautan dengan URL final bisa dibuka di tab baru.
const ButtonsPreview = ({ buttons, className = "", clickable = false }) => {
  const { t } = useTranslation();

  if (isEmpty(buttons)) {
    return null;
  }

  return (
    <div className={`divide-y divide-gray-300 ${className}`}>
      {buttons.map((button, index) => {
        const content = (
          <>
            {button?.type === "URL" ? <LuExternalLink /> : <LuReply />}
            <span className={button?.text ? "" : "text-gray-400"}>
              {button?.text || t("template.button_text")}
            </span>
          </>
        );
        const className =
          "flex items-center justify-center gap-x-2 py-2 px-2 text-primary";
        const url = clickable ? getOpenableUrl(button) : null;

        if (url) {
          return (
            <a
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${className} hover:underline`}
            >
              {content}
            </a>
          );
        }

        return (
          <div key={index} className={className}>
            {content}
          </div>
        );
      })}
    </div>
  );
};

export default ButtonsPreview;
